// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error_Error__2Cnz1","Error__text":"Error_Error__text__1z6CC"};